export default __webpack_public_path__ + "static/media/top-k-8-thumb.943f7810.jpg";